document.addEventListener('alpine:init', () => {
  let lastTrigger = null;

  const setPageState = (open) => {
    if (open) {
      document.documentElement.dataset.cardColourDrawerOpen = 'true';
      return;
    }

    delete document.documentElement.dataset.cardColourDrawerOpen;
  };

  const uniqueItems = (items = []) => {
    const seen = new Set();

    return items.filter((item) => {
      const url = String(item?.u || '').trim();

      if (!url || seen.has(url)) {
        return false;
      }

      seen.add(url);
      return true;
    });
  };

  Alpine.store('cardColourDrawer', {
    isOpen: false,
    title: '',
    items: [],

    openFrom(element) {
      if (!element) return;

      let linkedItems = [];

      try {
        const parsed = JSON.parse(
          element.dataset.colourItems || '[]'
        );

        linkedItems = Array.isArray(parsed)
          ? parsed
          : [];
      } catch (_) {
        linkedItems = [];
      }

        const currentItem = {
        c: element.dataset.currentColour || '',
        u: element.dataset.currentUrl || '',
        s: element.dataset.currentSwatch || '',
        i: element.dataset.currentImage || '',
        a: element.dataset.currentAvailable !== 'false',
        sale: element.dataset.currentSale === 'true',
        current: true,
        };

      this.title =
        element.dataset.productTitle || '';

      this.items = uniqueItems([
        currentItem,
        ...linkedItems.map((item) => ({
          ...item,
          current: false,
        })),
      ]);

      lastTrigger = element;

      this.isOpen = true;
      setPageState(true);

      window.FAFScrollLock?.lock?.(
        'card-colour-drawer'
      );
    },

    close() {
      if (!this.isOpen) {
        setPageState(false);
        return;
      }

      this.isOpen = false;
      setPageState(false);

      window.FAFScrollLock?.unlock?.(
        'card-colour-drawer'
      );

      const trigger = lastTrigger;
      lastTrigger = null;

      window.setTimeout(() => {
        trigger?.focus?.({
          preventScroll: true,
        });
      }, 0);
    },
  });

  Alpine.data('cardColourDrawer', () => ({
    init() {
      this.$watch(
        '$store.cardColourDrawer.isOpen',
        (open) => {
          if (!open) return;

          this.$nextTick(() => {
            this.$refs.close?.focus?.({
              preventScroll: true,
            });
          });
        }
      );
    },

    imageSrc(item) {
      const src = String(
        item?.i ||
        item?.s ||
        ''
      ).trim();

      if (!src) return '';

      /*
       * Current product image is already sized
       * by Liquid. This also protects any future
       * summary URL which already has a width.
       */
      if (/[?&]width=\d+/i.test(src)) {
        return src;
      }

      return `${src}${
        src.includes('?') ? '&' : '?'
      }width=640`;
    },

    trapFocus(event) {
      if (
        event.key !== 'Tab' ||
        !this.$refs.panel
      ) {
        return;
      }

      const focusable = Array.from(
        this.$refs.panel.querySelectorAll(
          [
            'a[href]',
            'button:not([disabled])',
            '[tabindex]:not([tabindex="-1"])',
          ].join(',')
        )
      ).filter(
        (element) =>
          element.offsetParent !== null
      );

      if (!focusable.length) {
        event.preventDefault();

        this.$refs.panel.focus({
          preventScroll: true,
        });

        return;
      }

      const first = focusable[0];
      const last =
        focusable[focusable.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    },

    destroy() {
      if (
        this.$store.cardColourDrawer.isOpen
      ) {
        this.$store.cardColourDrawer.close();
      } else {
        setPageState(false);
      }
    },
  }));
});